import axios from "axios";

export default async function fetchOtpComfirmationsSetting() {
    const url = `${process.env.NEXT_PUBLIC_OTP_COMFIRMATIONS_CDN}?q=${new Date().getTime()}`;
    let result = null;
    const res = await axios({
        method: "get",
        url: url,
    });
    if (res.status === 200) {
        result = res.data;
        console.log("🚀 ~ fetchOtpComfirmationsSetting ~ result:", result);
    }
    return result;
}
